<div class="wrapper-inner user_screen">
    <div class="container-fluid">
        <div class="row">

            <div class="col-md-12 userTables">
                <h2>new {{key}}</h2>
                <div class="row justify-content-center">
                    <div class="">
                        <form class="admin_form" [formGroup]="formData" (ngSubmit)="onSubmit()">
                            <div class="row justify-content-center">
                                <div class="col-md-8">
                                    <h2 class="user-title">Basic Information</h2>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="text-capitalize font-weight-bold mb-0">Full Name:</label>
                                                <small class="pull-right">[A-Z , a-z ,
                                                    0-9 , @ ] Allowed</small><br>
                                                <input type="text" name=""
                                                    [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
                                                    formControlName="name" id="" class="form-control">
                                                <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                                    <div *ngIf="f.name.errors.required">The Name field is
                                                        required</div>
                                                </div>
                                                <div *ngIf="submitted && resData && resData?.name && resData?.name.length > 0"
                                                    class="invalid-feedback">
                                                    <div *ngFor="let err of resData?.name">{{err}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="text-capitalize font-weight-bold mb-0">User Name:</label>
                                                <small class="pull-right">[A-Z , a-z ,
                                                    0-9 , @ ] Allowed</small><br>
                                                <input type="text" name=""
                                                    [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
                                                    formControlName="username" id=""
                                                    (keyup)="checkUserAvailability($event)" class="form-control">
                                                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                                                    <div *ngIf="f.username.errors.required">The Username field
                                                        is required</div>
                                                </div>
                                                <div *ngIf="submitted && resData && resData?.username && resData?.username.length > 0"
                                                    class="invalid-feedback">
                                                    <div *ngFor="let err of resData?.username">{{err}}</div>
                                                </div>
                                                <div *ngIf="f.error.value != '' && f.error.value != null"
                                                    class="invalid-feedback">
                                                    <div>{{f.error.value}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="text-capitalize font-weight-bold mb-0">Password:</label>
                                                <small class="pull-right">[A-Z , a-z ,
                                                    0-9 , @ ] Allowed</small><br>
                                                <input type="password" name=""
                                                    [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                                                    formControlName="password" id="" class="form-control">
                                                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                                    <div *ngIf="f.password.errors.required">The Password field
                                                        is required</div>
                                                </div>
                                                <div *ngIf="submitted && resData && resData?.password && resData?.password.length > 0"
                                                    class="invalid-feedback">
                                                    <div *ngFor="let err of resData?.password">{{err}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="text-capitalize font-weight-bold mb-0">Confirm
                                                    Password:</label> <small class="pull-right">[A-Z
                                                    , a-z , 0-9 , @ ] Allowed</small><br>
                                                <input type="password" name=""
                                                    [ngClass]="{ 'is-invalid': submitted && f.password_confirmation.errors }"
                                                    formControlName="password_confirmation" id="" class="form-control">
                                                <div *ngIf="submitted && f.password_confirmation.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.password_confirmation.errors.required">The
                                                        Confirm Password field is required</div>
                                                    <div *ngIf="f.password_confirmation.errors.mustMatch">The
                                                        Confirm Password confirmation does not match
                                                    </div>
                                                </div>
                                                <div *ngIf="submitted && resData && resData?.password_confirmation && resData?.password_confirmation.length > 0"
                                                    class="invalid-feedback">
                                                    <div *ngFor="let err of resData?.password_confirmation">
                                                        {{err}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12" [ngClass]="pa ? 'd-none':''">
                                            <div class="form-group">
                                                <label class="text-capitalize font-weight-bold mb-0">Free Chip:</label>
                                                <small class="pull-right">Remaining
                                                    Balance : {{data?.user?.remainBal}}</small><br>
                                                <input type="number" name=""
                                                    [ngClass]="{ 'is-invalid': submitted && f.free_chip.errors }"
                                                    formControlName="free_chip" id="" (change)="onChangeChip()"
                                                    class="form-control">
                                                <div *ngIf="submitted && f.free_chip.errors" class="invalid-feedback">
                                                    <div *ngIf="f.free_chip.errors.required">The Free Chip field is
                                                        required</div>
                                                </div>
                                                <div *ngIf="submitted && resData && resData?.free_chip && resData?.free_chip.length > 0"
                                                    class="invalid-feedback">
                                                    <div *ngFor="let err of resData?.free_chip">{{err}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-6" *ngIf="pa == false">

                                    </div> -->
                                    </div>

                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-md-8 pt-0">
                                    <h2 class="user-title">Partnerships</h2>
                                    <div class="form-row">
                                        <div class="row" *ngIf="actRoute.snapshot.paramMap.get('key') != 'client'">
                                            <div class="col-md-12" *ngFor="let item of eventTypes;let i=index;trackBy:trackByIndex;">
                                                <div class="row" *ngIf="partnerShip[item?.id]">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="text-capitalize font-weight-bold mb-0">Ratio
                                                                ({{item?.name}}):</label><br>
                                                            <input type="number" name=""
                                                                [(ngModel)]="partnerShip[item?.id].downlinePrt"
                                                                (ngModelChange)="onChanePrt(item)"
                                                                [ngModelOptions]="{standalone: true}" min="0" id=""
                                                                class="form-control">
                                                            <div *ngIf="submitted && (partnerShip[item?.id].downlinePrt === '' || partnerShip[item?.id].downlinePrt === null)"
                                                                class="invalid-feedback">
                                                                <div>The user ({{item?.name}}) partnership must be a
                                                                    Number</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label
                                                                class="text-capitalize font-weight-bold mb-0">&nbsp;</label><small
                                                                class="pull-right">Available Partnership:
                                                                {{partnerShip[item?.id]?.availablePrt}}</small><br>
                                                            <input type="number" name="" id=""
                                                                [(ngModel)]="partnerShip[item?.id].myPrt"
                                                                [ngModelOptions]="{standalone: true}"
                                                                class="form-control" disabled=""
                                                                placeholder="Your Prtnership Ratio">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="btn-group">
                                                <button class="btn btnSubmit" type="submit">submit</button>
                                                <button class="btn btnCancel">cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <app-loader class="full-overlay" *ngIf="submit"></app-loader>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>